// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboarding-filter-container{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    margin: 20px;
    align-items: center;
    justify-content: center;
}
.onboarding-filter-item {
    display: flex;
    gap: 8px;
    height: 40px;
    align-items: center;
}

.search-button{
    background-color: var(--primary-color);
    color: white;
    font-weight: bold;
    padding: 10px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    margin-top: 10px;
    height: 40px;
}
.onboarding-statistics-container{
    display: flex;
    flex-direction: column;
    overflow: scroll;
    height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/pages/onboarding-staticstic/onboarding-statistics.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,eAAe;IACf,SAAS;IACT,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,QAAQ;IACR,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,aAAa;AACjB","sourcesContent":[".onboarding-filter-container{\n    width: 100%;\n    display: flex;\n    flex-wrap: wrap;\n    gap: 20px;\n    margin: 20px;\n    align-items: center;\n    justify-content: center;\n}\n.onboarding-filter-item {\n    display: flex;\n    gap: 8px;\n    height: 40px;\n    align-items: center;\n}\n\n.search-button{\n    background-color: var(--primary-color);\n    color: white;\n    font-weight: bold;\n    padding: 10px 20px;\n    border: none;\n    border-radius: 5px;\n    cursor: pointer;\n    margin-top: 10px;\n    height: 40px;\n}\n.onboarding-statistics-container{\n    display: flex;\n    flex-direction: column;\n    overflow: scroll;\n    height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
